import * as React from "react";
import { connect } from "react-redux";
import * as Redux from "redux";

import * as connectActions from '../../../Connect/actions';
import * as diagnosticActions from '../../../Diagnostic/actions/diagnostics.js';
import * as grammarActions from '../../../Grammar/actions/session';
import * as evidenceActions from '../../../Evidence/actions/session';
import { Question } from '../../../Grammar/interfaces/questions';
import {
  returnActivity,
  returnActivityData,
  returnLessonData,
  renderTitleSection,
  renderQuestions,
  renderEvidenceActivityContent
} from "../../libs";

interface Activity {
  title?: string;
  name?: string;
  questions?: {
    key: string;
  }[];
  description?: string;
  landingPageHtml?: string;
  questionType?: string;
  flag?: string;
  modelConceptUID?: string;
}

const isConnectActivity = window.location.href.includes('connect');
const isDiagnosticActivity = window.location.href.includes('diagnostic');
const isGrammarActivity = window.location.href.includes('grammar');
const isEvidenceActivity = window.location.href.includes('evidence');

interface TeacherPreviewMenuProps {
  activity: Activity;
  dispatch: Function;
  fillInBlank: any[];
  isOnMobile: boolean;
  onHandleSkipToQuestionFromIntro?: () => void;
  onTogglePreview?: () => void;
  onToggleQuestion?: (question: Question | string) => void;
  lesson: any;
  questions: Question[];
  questionToPreview?: {
    key?: string,
    uid?: string
  };
  session: any;
  // Evidence closes the menu from its own header instead, so it opts out of this one.
  showCloseButton?: boolean;
  showPreview: boolean;
  titleCards: any;
}

export const TeacherPreviewMenuComponent = ({
  activity,
  dispatch,
  fillInBlank,
  isOnMobile,
  onHandleSkipToQuestionFromIntro,
  onTogglePreview,
  onToggleQuestion,
  lesson,
  questions,
  questionToPreview,
  session,
  showCloseButton = true,
  showPreview,
  titleCards
}: TeacherPreviewMenuProps) => {

  const [textIsExpanded, setTextIsExpanded] = React.useState<boolean>(false);

  React.useEffect(() => {
    if(session && session.previewSessionStep) {
      onToggleQuestion(session.previewSessionStep);
    }
  }, [session])

  function toggleExpandedText() {
    setTextIsExpanded(!textIsExpanded)
  }
  const handleToggleMenu = () => {
    onTogglePreview();
  }

  const handleQuestionUpdate = (e: React.SyntheticEvent) => {
    const questionUID = e.currentTarget.id;
    let question: Question;
    question = questions && questions[questionUID] || titleCards && titleCards[questionUID] || fillInBlank && fillInBlank[questionUID];
    question.key = questionUID;
    question.uid = questionUID;
    // again we use session for Grammar and playLesson for Connect
    if(!questionToPreview) {
      onHandleSkipToQuestionFromIntro();
    }
    let action;
    if(isDiagnosticActivity) {
      action = diagnosticActions.setCurrentQuestion(question)
    } else if(isConnectActivity) {
      action = connectActions.setCurrentQuestion(question);
    } else {
      action = grammarActions.setCurrentQuestion(question);
    }
    dispatch(action);
    onToggleQuestion(question);
  }

  const handleEvidenceStepUpdate = (e: React.SyntheticEvent) => {
    const evidenceStep = e.currentTarget.id;
    dispatch(evidenceActions.setPreviewSessionStep(evidenceStep))
    onToggleQuestion(evidenceStep);
  }

  const hiddenStyle = !showPreview ? 'hidden' : '';

  return (
    <aside className={`teacher-preview-menu-container ${hiddenStyle}`}>
      <section className="header-container">
        <h1>ACTIVITY PREVIEW</h1>
        {showCloseButton && (
          <button className="close-preview-button focus-on-light" onClick={handleToggleMenu} type="button">
            <img alt="Close preview menu" src={`${window.postbuildEnv.CDN_URL}/images/icons/close.svg`} />
            {isOnMobile && <p className="close-text">Close</p>}
          </button>
        )}
      </section>
      {renderTitleSection(activity)}
      <section className="preview-section">
        <p><strong>Preview Mode:</strong> This mode is only for teachers previewing. Students are not able to skip questions.</p>
      </section>
      <div className="divider" />
      {!isEvidenceActivity && <section>
        <h2>QUESTIONS</h2>
        <ul>
          {renderQuestions({
            activity,
            fillInBlank,
            handleQuestionUpdate,
            lesson,
            questions,
            questionToPreview,
            session,
            titleCards,
            isDiagnosticActivity
          })}
        </ul>
      </section>}
      {isEvidenceActivity && renderEvidenceActivityContent({
        activity,
        handleEvidenceStepUpdate,
        toggleExpandedText,
        textIsExpanded,
        questionToPreview
      })}
    </aside>
  );
}

const mapStateToProps = (state: any) => {
  const { questions, session, titleCards, fillInBlank, playLesson, playDiagnostic } = state;
  return {
    activity: returnActivity({ state, isGrammarActivity, isDiagnosticActivity, isConnectActivity, isEvidenceActivity }),
    fillInBlank: fillInBlank ? returnActivityData(fillInBlank) : null,
    lesson: returnLessonData({ playDiagnostic, playLesson, isConnectActivity, isDiagnosticActivity }),
    questions: questions ? returnActivityData(questions) : null,
    session: session,
    titleCards: titleCards ? returnActivityData(titleCards) : null,
  };
};

const mapDispatchToProps = (dispatch: Redux.Dispatch<any>) => {
  return {
    dispatch
  };
};

export const TeacherPreviewMenu = connect(mapStateToProps, mapDispatchToProps)(TeacherPreviewMenuComponent);
